import { StyleSheet } from 'react-native';

export default StyleSheet.create({
    container: {
        flex: 1
    },
    centeredcontainer: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    background1: {
        backgroundColor: '#575757'
    },
    background2: {
        backgroundColor: '#202020'
    },
    background3: {
        backgroundColor: '#2a2a2a'
    },
    background4: {
        backgroundColor: '#343434'
    },
    font1: {
        color: '#DDD'
    },
    font2: {
        color: '#FFF'
    },
    highlightFont: {
        color: '#F6C042'
    },
    inputText: {
        backgroundColor: '#FFF',
        color: "#000",
        borderWidth: 1,
        borderColor: "#000",
        padding: 5
    },
    missingArtworkColor1: {
        backgroundColor: '#006aff'
    },
    missingArtworkColor2: {
        backgroundColor: '#9500ff'
    },
    missingArtworkColor3: {
        backgroundColor: '#ff006a'
    },
    missingArtworkColor4: {
        backgroundColor: '#ff9500'
    },
    missingArtworkColor5: {
        backgroundColor: '#49b100'
    }
});